import { HttpErrorResponse } from '@angular/common/http';
import { IRegistration } from '@app/modules/auth/interface/registration';
import { ILogin } from '@app/modules/auth/interface/login';
import { IRegistrationConfirm } from '@app/modules/auth/interface/registration-confirm';
import { IPasswordRestore } from '@app/modules/auth/interface/password-restore';
import { IPasswordRestoreConfirm } from '@app/modules/auth/interface/password-restore-confirm';
import { IPasswordChange } from '@app/modules/auth/interface/password-change';
import {IPasswordReset} from "@app/modules/auth/interface/password-reset";

export namespace AuthActions {
  /**
   * @action Registration
   */
  export class Registration {
    static type = '[Auth] Registration';
    constructor(public value: IRegistration) {}
  }
  export class RegistrationSuccess {
    static type = '[Auth] RegistrationSuccess';
  }
  export class RegistrationFailed {
    static type = '[Auth] RegistrationFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action RegistrationConfirm
   */
  export class RegistrationConfirm {
    static type = '[Auth] RegistrationConfirm';
    constructor(public value: IRegistrationConfirm) {}
  }
  export class RegistrationConfirmSuccess {
    static type = '[Auth] RegistrationConfirmSuccess';
  }
  export class RegistrationConfirmFailed {
    static type = '[Auth] RegistrationConfirmFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action Login
   */
  export class Login {
    static type = '[Auth] Login';
    constructor(public value: ILogin) {}
  }
  export class LoginSuccess {
    static type = '[Auth] LoginSuccess';
  }
  export class LoginFailed {
    static type = '[Auth] LoginFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action GoogleLogin — sign in with a Google ID token. Reuses
   * LoginSuccess / LoginFailed so the downstream flow matches password login.
   */
  export class GoogleLogin {
    static type = '[Auth] GoogleLogin';
    constructor(public idToken: string) {}
  }

  /**
   * @action Logout
   */
  export class Logout {
    static type = '[Auth] Logout';
  }
  export class LogoutSuccess {
    static type = '[Auth] LogoutSuccess';
  }
  export class LogoutFailed {
    static type = '[Auth] LogoutSuccess';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action PasswordChange
   */
  export class PasswordChange {
    static type = '[Auth] PasswordChange';
    constructor(public value: IPasswordChange) {}
  }

  export class PasswordReset {
    static type = '[Auth] PasswordReset';
    constructor(public value: IPasswordReset) {}
  }

  export class PasswordChangeSuccess {
    static type = '[Auth] PasswordChangeSuccess';
  }
  export class PasswordChangeFailed {
    static type = '[Auth] PasswordChangeFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action PasswordRestore
   */
  export class PasswordRestore {
    static type = '[Auth] PasswordRestore';
    constructor(public value: IPasswordRestore) {}
  }
  export class PasswordRestoreSuccess {
    static type = '[Auth] PasswordRestoreSuccess';
    constructor(public value: IPasswordRestore) {}
  }

  export class PasswordResetSuccess {
    static type = '[Auth] PasswordResetSuccess';
    constructor(public value: IPasswordReset) {}
  }

  export class PasswordResetFailure {
    static type = '[Auth] PasswordResetFailure';
    constructor(public error?: HttpErrorResponse) {}
  }

  export class PasswordRestoreFailed {
    static type = '[Auth] PasswordRestoreFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action PasswordRestoreConfirm
   */
  export class PasswordRestoreConfirm {
    static type = '[Auth] PasswordRestoreConfirm';
    constructor(public value: IPasswordRestoreConfirm) {}
  }
  export class PasswordRestoreConfirmSuccess {
    static type = '[Auth] PasswordRestoreConfirmSuccess';
  }
  export class PasswordRestoreConfirmFailed {
    static type = '[Auth] PasswordRestoreConfirmFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  export class IsInviteURL {
    static type = '[Auth] IsInviteURL';
  }
}
